export default "__VITE_ASSET__55b2cb40__"